<div class="viewer">
  <header class="viewer-header">
    <div class="titles">
      <span class="viewer-title">Research — {{ data.brandName }}</span>
      <span class="viewer-meta" *ngIf="selectedMeta() as meta">
        <ng-container *ngIf="meta.researchedAt">Researched {{ meta.researchedAt | date: 'MMM d, y HH:mm' }}</ng-container>
        <ng-container *ngIf="meta.researchedAt && meta.validFrom"> · </ng-container>
        <ng-container *ngIf="meta.validFrom">estimates valid from {{ meta.validFrom }}</ng-container>
      </span>
    </div>
    <button type="button" class="viewer-close" (click)="close()" aria-label="Close">×</button>
  </header>

  <div class="country-tabs" *ngIf="countries.length > 1" role="tablist">
    <button type="button" role="tab" *ngFor="let country of countries" class="country-tab"
      [class.active]="selectedCountry() === country" [attr.aria-selected]="selectedCountry() === country"
      (click)="select(country)">{{ country }}</button>
  </div>

  <div class="viewer-body">
    <div class="body-loader" *ngIf="loading()"><app-loader></app-loader></div>

    <div class="viewer-error" *ngIf="error() as message">
      <span>{{ message }}</span>
      <button type="button" class="link-button" (click)="retry()">Retry</button>
    </div>

    <ng-container *ngIf="memory() as researchMemory">
      <div class="memory-panel">
        <app-markdown class="memory-markdown" [rawMarkdown]="researchMemory.content" [block]="true"></app-markdown>
      </div>
      <div class="memory-footer" *ngIf="researchMemory.lastModified">
        Research file updated {{ researchMemory.lastModified | date: 'MMM d, y HH:mm' }}
      </div>
    </ng-container>
  </div>
</div>
